import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { fetchVotesFailure, fetchVotesSuccess } from "./actions";
import { FETCH_VOTES } from "./constants";
import { formatFeedVotes } from "../../Containers/Roster/Feed/feedConstants";

export function* fetchVotesSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/feed-poll-stats/${payload}`
    );
    const formattedVotes = formatFeedVotes(data);
    yield put(fetchVotesSuccess(formattedVotes));
  } catch (e) {
    yield put(fetchVotesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching vote list!"));
  }
}

export function* fetchVotesFlow() {
  yield takeEvery(FETCH_VOTES, fetchVotesSaga);
}

export default function* FeedVotesSaga() {
  yield all([fetchVotesFlow()]);
}
